<div class="lookup-key-options__fields">
  <app-column-template-input
    class="lookup-key-options__wide"
    [control]="controls.lookupKeyTemplateControl"
    [columns]="columns"
    label="TRANS__IMPORT__LOOKUP_KEY_TEMPLATE"
  ></app-column-template-input>
  @if (unknownKeyColumns.length) {
    <p class="lookup-key-options__warning lookup-key-options__wide">
      {{ 'TRANS__IMPORT__UNKNOWN_PLACEHOLDER' | translate }}: {{ unknownKeyColumns.join(', ') }}
    </p>
  }

  <mat-form-field appearance="outline" subscriptSizing="dynamic">
    <mat-label>{{ 'TRANS__IMPORT__LOOKUP_FALLBACK_SUFFIX' | translate }}</mat-label>
    <input matInput [formControl]="controls.lookupFallbackSuffixControl">
  </mat-form-field>

  <mat-checkbox [formControl]="controls.lookupCaseInsensitiveControl">
    {{ 'TRANS__IMPORT__LOOKUP_CASE_INSENSITIVE' | translate }}
  </mat-checkbox>

  <mat-form-field appearance="outline" subscriptSizing="dynamic" class="lookup-key-options__wide">
    <mat-label>{{ 'TRANS__IMPORT__LOOKUP_ALIASES' | translate }}</mat-label>
    <textarea
      matInput
      rows="3"
      [formControl]="controls.lookupAliasesControl"
    ></textarea>
    <mat-hint>{{ 'TRANS__IMPORT__LOOKUP_ALIASES_HINT' | translate }}</mat-hint>
  </mat-form-field>
</div>
